export const PROPERTY_ENDPOINT = {
  detail: `${import.meta.env.VITE_APP_API}/properties/get-property`,
  list: `${import.meta.env.VITE_APP_API}/properties/get-properties`,
  getOwnersOfProperty: `${import.meta.env.VITE_APP_API}/owners/get-owners`,
  getPropertiesForUnit: `${
    import.meta.env.VITE_APP_API
  }/properties/get-properties`,
  archive: `${import.meta.env.VITE_APP_API}/properties/archive-property`,
  delete: `${import.meta.env.VITE_APP_API}/properties/delete-property`,
  toggleStatus: `${
    import.meta.env.VITE_APP_API
  }/properties/activate-or-block-property`,
  bulkToggleStatus: `${
    import.meta.env.VITE_APP_API
  }/properties/bulk-activate-or-block-property`,
  restore: `${import.meta.env.VITE_APP_API}/properties/restore-property`,
  archivedProperties: `${
    import.meta.env.VITE_APP_API
  }/properties/get-archived-properties`,
  archivedProperty: `${
    import.meta.env.VITE_APP_API
  }/properties/get-archived-property`,
  create: `${import.meta.env.VITE_APP_API}/properties/create-property`,
  update: `${import.meta.env.VITE_APP_API}/properties/update-property`,
  getUnits: `${import.meta.env.VITE_APP_API}/properties/get-units`,
  addUnit: `${import.meta.env.VITE_APP_API}/properties/add-unit`,
  updateUnit: `${import.meta.env.VITE_APP_API}/properties/update-unit`,
  removeUnit: `${import.meta.env.VITE_APP_API}/properties/remove-unit`,
  toggleUnitStatus: `${
    import.meta.env.VITE_APP_API
  }/properties/activate-or-block-unit`,
  bulkToggleUnitStatus: `${
    import.meta.env.VITE_APP_API
  }/properties/bulk-activate-or-block-unit`,
  export: `${import.meta.env.VITE_APP_API}/properties/export-properties`,
}
